import "react-app-polyfill/ie11";
import { createRoot } from "react-dom/client";
import "core-js";

// provider for api calls
import { QueryClient, QueryClientProvider } from "react-query";

// provider for local contexts
import {
  ParamsProvider,
  UserProvider,
  AdminProvider,
} from "./contexts";

//components
import NetworkStatus from "./components/NetworkStatus";

// Bootstrap CSS and JS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// PrimeReact
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./index.css";

// Routes
import Routes from "./Routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <PrimeReactProvider>
    <UserProvider>
      <AdminProvider>
        <QueryClientProvider client={queryClient}>
          <ParamsProvider>
            <Routes />
            <NetworkStatus />
          </ParamsProvider>
        </QueryClientProvider>
      </AdminProvider>
    </UserProvider>
  </PrimeReactProvider>,
);
